var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3794_7598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4996 8.15625H3.7498C3.36305 8.15625 3.0498 7.8416 3.0498 7.45312C3.0498 7.06465 3.36305 6.75 3.7498 6.75H10.4996C10.8863 6.75 11.1996 7.06465 11.1996 7.45312C11.1996 7.8416 10.8863 8.15625 10.4996 8.15625Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4996 10.9688H3.7498C3.36305 10.9688 3.0498 10.6541 3.0498 10.2656C3.0498 9.87715 3.36305 9.5625 3.7498 9.5625H10.4996C10.8863 9.5625 11.1996 9.87715 11.1996 10.2656C11.1996 10.6541 10.8863 10.9688 10.4996 10.9688Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4996 13.7812H3.7498C3.36305 13.7812 3.0498 13.4666 3.0498 13.0781C3.0498 12.6896 3.36305 12.375 3.7498 12.375H10.4996C10.8863 12.375 11.1996 12.6896 11.1996 13.0781C11.1996 13.4666 10.8863 13.7812 10.4996 13.7812Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 1.40625H9.6796C9.3905 0.587812 8.61245 0 7.7 0H6.3C5.38755 0 4.6095 0.587812 4.3204 1.40625H2.1C0.9422 1.40625 0 2.35266 0 3.51562V15.8906C0 17.0536 0.9422 18 2.1 18H11.9C13.0578 18 14 17.0536 14 15.8906V3.51562C14 2.35266 13.0578 1.40625 11.9 1.40625ZM6.3 1.40625H7.7C8.08605 1.40625 8.4 1.7216 8.4 2.10938C8.4 2.49715 8.08605 2.8125 7.7 2.8125H6.3C5.91395 2.8125 5.6 2.49715 5.6 2.10938C5.6 1.7216 5.91395 1.40625 6.3 1.40625ZM12.6 15.8906C12.6 16.2784 12.286 16.5938 11.9 16.5938H2.1C1.71395 16.5938 1.4 16.2784 1.4 15.8906V3.51562C1.4 3.12785 1.71395 2.8125 2.1 2.8125H4.3204C4.6095 3.63094 5.38755 4.21875 6.3 4.21875H7.7C8.61245 4.21875 9.3905 3.63094 9.6796 2.8125H11.9C12.286 2.8125 12.6 3.12785 12.6 3.51562V15.8906Z",
    fill: "#2060EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3794_7598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryIcon);
export default __webpack_public_path__ + "static/media/inventoryIcon.b0af688e188d2b18dd366e58928c1962.svg";
export { ForwardRef as ReactComponent };